import { useI18n } from '../../i18n/i18n-context';
import { useAccount } from './account-context';
import { AccountFrame } from './AccountFrame';
import { ApiKeysDialog } from './ApiKeysDialog';
import { BillingDialog } from './BillingDialog';
import { SignInForm } from './SignInForm';
import { AiToolsDialog } from './AiToolsDialog';
import { InstructionsDialog } from './InstructionsDialog';
import { PlanChooser } from './PlanChooser';
import { usePlanChooser } from './usePlanChooser';
import { TonesDialog } from './TonesDialog';

function PlansDialog() {
  const { t } = useI18n();
  const { dialog, closeDialog } = useAccount();
  const chooser = usePlanChooser();

  function close() {
    chooser.reset();
    closeDialog();
  }

  return (
    <AccountFrame
      open={dialog === 'plans'}
      onClose={close}
      title={chooser.title}
      wide={chooser.step === 'plans'}
    >
      {chooser.step === 'plans' && <p className="dialog-intro">{t.plans.intro}</p>}
      <PlanChooser chooser={chooser} onChanged={close} />
    </AccountFrame>
  );
}

function SignInDialog() {
  const { t } = useI18n();
  const { dialog, closeDialog } = useAccount();
  return (
    <AccountFrame open={dialog === 'sign-in'} onClose={closeDialog} title={t.signIn.title}>
      <SignInForm intro={t.signIn.intro} />
    </AccountFrame>
  );
}

export function AccountDialogs() {
  return (
    <>
      <PlansDialog />
      <BillingDialog />
      <SignInDialog />
      <TonesDialog />
      <InstructionsDialog />
      <AiToolsDialog />
      <ApiKeysDialog />
    </>
  );
}
